module.exports = __webpack_public_path__ + "static/other/gameZoo.1a38fe76.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameZoo.json
// module id = 2524
// module chunks = 0